(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Stately-stately-concurrency'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Stately-stately-concurrency'.");
    }
    root['Stately-stately-concurrency'] = factory(typeof this['Stately-stately-concurrency'] === 'undefined' ? {} : this['Stately-stately-concurrency'], this['kotlin-kotlin-stdlib']);
  }
}(globalThis, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.hb;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ThreadLocalRef, 'ThreadLocalRef', ThreadLocalRef);
  //endregion
  function set_value(_this__u8e3s4, value) {
    _this__u8e3s4.d2e(value);
  }
  function ThreadLocalRef() {
    this.c2e_1 = null;
  }
  protoOf(ThreadLocalRef).w3 = function () {
    set_value(this, null);
  };
  protoOf(ThreadLocalRef).os = function () {
    return this.c2e_1;
  };
  protoOf(ThreadLocalRef).d2e = function (value) {
    this.c2e_1 = value;
  };
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = ThreadLocalRef;
  //endregion
  return _;
}));
